import cn from 'classnames';

/**
 * Soft container for PBM flows embedded in the product purchase options card
 * (avoids the standalone white SquaredBox + duplicate header).
 */
export function PbmEmbeddedShell({
  children,
  className,
}: Readonly<{
  children: React.ReactNode;
  className?: string;
}>) {
  return (
    <div
      className={cn(
        'w-full rounded-lg px-3 pb-4 shadow-none sm:px-4',
        className,
      )}
    >
      {children}
    </div>
  );
}
